// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import CampaignCauseController from "./campaign_cause_controller"
application.register("campaign-cause", CampaignCauseController)

import CampaignFixedCtaController from "./campaign_fixed_cta_controller"
application.register("campaign-fixed-cta", CampaignFixedCtaController)

import CharityBaseController from "./charity_base_controller"
application.register("charity-base", CharityBaseController)

import ConfettiController from "./confetti_controller"
application.register("confetti", ConfettiController)

import CountdownController from "./countdown_controller"
application.register("countdown", CountdownController)

import DeepNestedFormController from "./deep_nested_form_controller"
application.register("deep-nested-form", DeepNestedFormController)

import DrawController from "./draw_controller"
application.register("draw", DrawController)

import FollowsController from "./follows_controller"
application.register("follows", FollowsController)

import FormController from "./form_controller"
application.register("form", FormController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import HomeVideoController from "./home_video_controller"
application.register("home-video", HomeVideoController)

import HoneybadgerController from "./honeybadger_controller"
application.register("honeybadger", HoneybadgerController)

import ItemPurchasesController from "./item_purchases_controller"
application.register("item-purchases", ItemPurchasesController)

import MoneyController from "./money_controller"
application.register("money", MoneyController)

import PurchasesController from "./purchases_controller"
application.register("purchases", PurchasesController)

import RecordAttachmentsController from "./record_attachments_controller"
application.register("record-attachments", RecordAttachmentsController)

import ReloadController from "./reload_controller"
application.register("reload", ReloadController)

import ScrollToController from "./scroll_to_controller"
application.register("scroll-to", ScrollToController)

import ShareController from "./share_controller"
application.register("share", ShareController)

import SlideController from "./slide_controller"
application.register("slide", SlideController)

import StripeController from "./stripe_controller"
application.register("stripe", StripeController)

import ToggleController from "./toggle_controller"
application.register("toggle", ToggleController)

import UppyController from "./uppy_controller"
application.register("uppy", UppyController)

import WinsController from "./wins_controller"
application.register("wins", WinsController)

import YoutubeController from "./youtube_controller"
application.register("youtube", YoutubeController)
